var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_vm._v("SOMET TEXT")]),_c('ReportDesignerComponent')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }